import { Component, OnInit, ViewChild, AfterViewInit, Input, EventEmitter, Output, OnChanges, KeyValueDiffers, KeyValueDiffer, KeyValueChanges, SimpleChanges, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute, Params, UrlSegment } from '@angular/router';
import { UntypedFormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, Validators, ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, AbstractControl, ValidationErrors, ReactiveFormsModule, FormControl } from '@angular/forms'
import { Global } from '../Shared/global';
import { CommonDataService } from '../Services/commonDataService';
import { AppContext, IComponent } from '../Shared/common';
import { DBOperation, DataStatus, GENDER, DataFor, ControlDisplayMode, AddressType, UserType, ReminderDisplayMode, ReminderTypes } from '../Shared/enum';
import { ICountry } from '../Models/Country';
import { ITax, TaxComponent, TaxComponentValues } from '../Models/Tax';
import { filter } from 'rxjs/operators';
import { Member } from '../Models/FitnessBox/Member';
import { DateAdapter } from '@angular/material/core';
/*import { Observable } from 'rxjs-compat';*/
import { FileUploadService } from '../Services/fileUploadService';
import { ICommonImage } from '../Models/CommonImage';
import { PaymentDetail } from '../Models/FitnessBox/PaymentDetail';
import { User } from '../Models/FitnessBox/User';
import { CommonSetting, CommonSettings } from '../Models/Common/CommonSettings';
import { Screen } from '../Models/Screen';
import { Reminder } from '../Models/Common/Reminder';
import { AppModule } from '../Models/Common/AppModule';
import { Employee } from '../Models/FitnessBox/Employee';

@Component({
  templateUrl: './guestAddFollowupComponent.html',
  styleUrls: ['./guestComponent.css'],
  selector: 'add-guestfollowup'
})
//, ControlValueAccessor
export class GuestAddFollowupComponent implements OnInit, AfterViewInit, OnChanges {
  routeLinks: any[];
  activeLinkIndex = -1;
  @Input() memberForm: UntypedFormGroup;
  formInvalid: boolean = false;
  memberFormToPost: UntypedFormGroup;
  component: IComponent = new DataComponent();
  @ViewChild('modal', /* TODO: add static flag */ {}) modal: NgxSmartModalService;
  @ViewChild('searchedmember', /* TODO: add static flag */ {}) searchedmember;

  @Input() ReminderDisplayMode: any = ReminderDisplayMode;
  @Input() EnumDataFor: any = DataFor;
  @Input() EnumDisplayMode: any = ControlDisplayMode;
  @Input() dataList: [] = null;
  @Input() message: string = '';
  @Input() selectedItemTax: ITax;
  @Output() itemChange = new EventEmitter();
  @Input() status: DataStatus;
  @Input() selectedMember: Member = new Member();
  @Input() operationType: DBOperation;
  @Input() isPartialAdminUser: boolean = false;
  @Input() isAdminUser: boolean = false;
  @Input() currentScreen: Screen = new Screen();
  modalTitle: string = "Member Invoice";
  globalSetting: GlobalSettings = new GlobalSettings();
  invSettings: InvoiceSetting = new InvoiceSetting();
  currentInvoice: InvoicePrintData = new InvoicePrintData();
  currentUser: User;
  controllerUrl: string;
  @Input() selectedImageItem: ICommonImage;
  newPaymentDetail: PaymentDetail = new PaymentDetail();
  relativeTempUploadPath: string = "http://localhost:2001/Data/TempUpload/";
  uploadError: string;
  error: string;
  packageValidationError: string;

  //Input Helpers
  pricingModel = PricingModel;
  genderList = GENDER;
  genderEnums = [];
  addressTypes = AddressType;
  addressTypeEnums = [];
  photoIdTypes = PhotoIdType;
  photoIdTypesEnums = [];
  paymentModes = PayMode;
  paymentModeEnums = [];
  salutations = ["Mr.", "Mrs.", "Ms."];
  minDate: Date;
  maxDate: Date;
  step = -1;
  showProgress: boolean = false;
  groupedPlans: any[];
  planDurations: number[];
  selectedGroupPlan: any;
  selectedPlanDuration: number;
  displayDurationOptions: boolean = false;
  membershipPlans: UserMembershipPlan[];
  defaultState: string = "Maharashtra";
  selectedInvoiceId: number = 0;
  isEditMode: boolean = false;
  isUpgradeMode: boolean = false;
  profileImageUrl: string = 'assets/images/profile_icon_small.png';
  commonSetting: CommonSettings;
  mergeFullName: boolean = false;
  newFollowup: Reminder = new Reminder();
  incompleteReminders: number = 0;
  currentDate: Date = new Date();
  allowInvoiceDiscount: boolean = true;

  SubTypeList: ReminderType[] = [];
  ResponseTypeList: ReminderResponseType[] = [];


  constructor(private router: Router, private fb: UntypedFormBuilder, private _service: CommonDataService, private differs: KeyValueDiffers,
    private dateAdapter: DateAdapter<Date>, private route: ActivatedRoute,
    private _fileservice: FileUploadService,
    private renderer: Renderer2,
    private appctx: AppContext
  ) {
    this.genderEnums = Object.keys(this.genderList).filter(f => !isNaN(Number(f)));
    this.addressTypeEnums = Object.keys(this.addressTypes).filter(f => !isNaN(Number(f)));
    this.paymentModeEnums = Object.keys(this.paymentModes).filter(f => !isNaN(Number(f)));
    this.photoIdTypesEnums = Object.keys(this.photoIdTypes).filter(f => !isNaN(Number(f)));
    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear - 80, 0, 1);
    this.maxDate = new Date(currentYear + 5, 0, 1);
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    this.invSettings.CalculateTaxOnSale = true;
    this.invSettings.CalculateTaxAfterDiscount = true;
    this.controllerUrl = Global.BASE_USER_ENDPOINT() + Global.FileUploadController;
    this.currentUser = appctx.CurrentUser;
    this.currentDate.setHours(0, 0, 0, 0);
  }

  //fired when Angular detects changes to the @Input properties
  ngOnChanges(changes: SimpleChanges) {
    //Make sure a valid member is selected
    if (this.selectedMember && this.selectedMember.MembershipId && this.selectedMember.MembershipId > 0) {
      this.GetDataToEdit(this.selectedMember.MembershipId);
    }
  }

  ngDoCheck(): void {
    //alert('something changed in ngDoCheck');
    //Global.Log('something changed in ngDoCheck');
  }

  ngOnInit() {
    this.InitializeDefaults();
    this.adjustFieldVisibility();
  }

  ngAfterViewInit() {
  }

  openAccordionTab(index: number) {
    if (!this.isEditMode || (this.isEditMode && index != 1)) {
      this.step = index;
    }
  }

  adjustFieldVisibility() {
    if (this.appctx.AppConfigurations &&
      this.appctx.AppConfigurations.CustomSettings &&
      this.appctx.AppConfigurations.CustomSettings.MergeFullName
    ) {
      this.mergeFullName = this.appctx.AppConfigurations.CustomSettings.MergeFullName;
    }
  }

  createForm() {


  }

  clearForm() {
    this.selectedMember.Address = [];
    this.selectedMember.AlternateEmail = "";
    this.selectedMember.Contact1 = "";
    this.selectedMember.Contact2 = "";
    this.selectedMember.EnrolledBy = null;
    this.selectedMember.Name = "";
    this.selectedMember.FirstName = "";
    this.selectedMember.LastName = "";
    this.selectedMember.Salutation = "";
    this.selectedMember.UserName = "";
    this.selectedMember.UserRef = "";
    this.selectedMember.UserGuid = "";
    this.selectedMember.Status = "";
    this.selectedMember.Address = [];
    this.selectedMember.Email = "";
    this.selectedMember.AlternateEmail = "";
    this.selectedMember.Occupation = "";
    this.selectedMember.IsActive = true;
    this.selectedMember.ReferredBy = null;
    this.selectedMember.EnrolledBy = null;
    this.selectedMember.UserMemberships = [];
    this.selectedMember.Goal = null;
    this.selectedMember.IdentityId = "";
    this.selectedMember.PhotoIdType = PhotoIdType.AADHAR;
    this.selectedMember.PhotoIdValue = "";
    this.selectedMember.Remarks = "";
    this.selectedMember.UserImages = [];
    this.selectedMember.Measurements = [];
    this.selectedMember.InvoiceDetails = [];
  }

  InitializeDefaults() {
    this.selectedMember = new Member();
    this.selectedMember.UserType = UserType.MEMBER;
    this.selectedMember.UserImages = [];
    this.selectedMember.Measurements = [];
    this.selectedMember.InvoiceDetails = [];
    this.selectedMember.InvoiceDetails.push(new MemberInvoice());
    this.selectedMember.InvoiceDetails[0].InvoiceDate = new Date();
    this.selectedMember.InvoiceDetails[0].InvoiceId = 0;
    this.selectedMember.InvoiceDetails[0].IsGstIncludedInPrice = true;
    this.selectedMember.InvoiceDetails[0].PaymentDetails = [];
    this.selectedMember.InvoiceDetails[0].PreparedByUser = this.currentUser;
    //this.selectedMember.InvoiceDetails[0].PaymentDetails.push(this.newPaymentDetail);
    this.selectedMember.Address = [];
    this.selectedMember.UserMemberships = [];
    this.globalSetting.StoreTaxRate = <ITax>{};
    this.selectedMember.DateOfBirth = new Date();

    if (this.selectedMember.CreateDate instanceof Date == false || this.selectedMember.CreateDate.getFullYear() == 1) {
      this.selectedMember.CreateDate = new Date();
    }
    if (this.selectedMember.LastupdateDate instanceof Date == false || this.selectedMember.LastupdateDate.getFullYear() == 1) {
      this.selectedMember.LastupdateDate = new Date();
    }

    this.route.params
      .pipe(filter(params => params.id))
      .subscribe(params => {
        //Global.Log(params);
        if (params.id != undefined && params.id != null) {
          this.GetDataToEdit(params.id);
        }
      });


    this.commonSetting = new CommonSettings();
    this.commonSetting.Settings = [];

    let adminFeeSet: CommonSetting = new CommonSetting();
    let adminFeeInterval: CommonSetting = new CommonSetting();
    adminFeeSet.Key = "AdminFee";
    adminFeeSet.Value = "200";
    adminFeeSet.IsActive = true;
    adminFeeSet.Key = "AdminFeeInterval";
    adminFeeSet.Value = "OneTime";
    adminFeeSet.IsActive = true;
    this.commonSetting.Settings.push(adminFeeSet);
    this.commonSetting.Settings.push(adminFeeInterval);
    if (this.appctx.CurrentScreen) {
      this.currentScreen = this.appctx.CurrentScreen;
      this.isPartialAdminUser = this.currentScreen.CanEdit && this.currentScreen.CanDelete;
    }
    this.populateFollowups();
    this.isAdminUser = (this.currentUser.UserType == UserType.ADMIN || this.currentUser.UserType == UserType.OWNER);
  }

  populateFollowups() {
    this.newFollowup = new Reminder();
    this.newFollowup.OrgId = this.selectedMember.OrgId;
    this.newFollowup.UnitId = this.selectedMember.UnitId;
    this.newFollowup.RelatedModule = new AppModule();
    this.newFollowup.RelatedModule.ModuleName = "Inquiry";
    this.newFollowup.RelatedModule.ModuleId = 7;
    this.newFollowup.CreatedBy = this.currentUser;
    this.newFollowup.Source = "USER";
    this.newFollowup.IsActive = true;
    this.newFollowup.ReminderType = ReminderTypes.Inquiry;
    this.newFollowup.DisplayMode = ReminderDisplayMode.Text;
    this.newFollowup.ReminderDateTime = this.currentDate;

    if (this.selectedMember && !this.selectedMember.Reminders) {
      this.selectedMember.Reminders = [];
    }
    else if (this.selectedMember && this.selectedMember.Reminders) {
      for (var rCount = 0; rCount < this.selectedMember.Reminders.length; rCount++) {
        this.selectedMember.Reminders[rCount].ReminderDateTime = new Date(this.selectedMember.Reminders[rCount].ReminderDateTime);
      }
    }

    this.LoadFollowupDefaults();
  }

  onFormSubmit(formValue) {
    this.translateFormToPost();
    this.component.dbops = DBOperation.create;
    Global.onSubmit(this.memberFormToPost, this.component, this._service, Global.ProductController, false, null);
  }

  onSubmit(formValue) {
    this.itemChange.emit(formValue);
  }

  compareObjects(o1: any, o2: any): boolean {
    return Global.compareObjects(o1, o2);
  }

  hasValidFollowup() {
    return ((this.newFollowup && this.newFollowup.ReminderDateTime && this.newFollowup.ReminderDateTime instanceof Date != false && this.newFollowup.ReminderDateTime.getFullYear() != 1
      && this.newFollowup.ReminderDetails && this.newFollowup.ReminderDetails.trim() != ""
    ) ||
      (this.selectedMember &&
        this.selectedMember.Reminders &&
        this.selectedMember.Reminders.length > 0 &&
        !(this.selectedMember.Reminders[0].ReminderDateTime < this.currentDate)
      )
    );
  }

  hasConsultantForPT() {
    let isPackagesValid: boolean = true;
    this.packageValidationError = "Please provide consultant and incentive % for:";

    for (var umCnt = 0; umCnt < this.selectedMember.UserMemberships?.length; umCnt++) {
      if (this.selectedMember.UserMemberships[umCnt].IsPersonalized
        && ((!this.selectedMember.UserMemberships[umCnt].Consultant || this.selectedMember.UserMemberships[umCnt].Consultant.toString() == "")
          || (!this.selectedMember.UserMemberships[umCnt].CommissionPerc || this.selectedMember.UserMemberships[umCnt].CommissionPerc == 0))
      ) {
        isPackagesValid = false;
        this.packageValidationError += " " + this.selectedMember.UserMemberships[umCnt].Name + ",";
      }
    }

    if (isPackagesValid) {
      this.packageValidationError = "";
    }

    return isPackagesValid;
  }

  onSave() {
    this.showProgress = true;
    try {

      if (this.newFollowup && this.newFollowup.ReminderDateTime && this.newFollowup.ReminderDateTime instanceof Date != false && this.newFollowup.ReminderDateTime.getFullYear() != 1
        && this.newFollowup.ReminderDetails && this.newFollowup.ReminderDetails.trim() != ""
      ) {
        for (var idx = 0; idx < this.selectedMember.Reminders.length; idx++) {
          this.selectedMember.Reminders[idx].IsCompleted = true;
        }
        this.newFollowup.ReminderDateTime = new Date(this.newFollowup.ReminderDateTime);
        this.selectedMember.Reminders.push(this.newFollowup);
        this.selectedMember.NextFollowUpDate = new Date(this.newFollowup.ReminderDateTime);
        this.selectedMember.FollowUpRemarks = this.newFollowup.ReminderDetails;
      }


      if (this.selectedMember && this.selectedMember.Reminders && this.selectedMember.Reminders.length > 0) {
        Global.onSubmitData(this.selectedMember, DBOperation.update, this._service, (Global.BASE_USER_ENDPOINT() + Global.GuestMemberController), this.memberSaved, this);
      }
      else {
        this.showProgress = false;
      }


    } catch (e) {
      this.status = 2;
      this.message = "Error on saving data !!!"
    }

  }

  onSavePrint() {
    //const url = this.router.serializeUrl(
    //  this.router.createUrlTree(['/printMemberInvoice/' + this.selectedMember.ID])
    //);

    //let baseUrl: string = window.location.href;
    //baseUrl = baseUrl.split('#')[0];
    //window.open(baseUrl + "#" + url, '_self');

    this.modal.open('modal', false);
  }

  memberSaved(data, context) {
    context.showProgress = false;
    if (data != undefined && data != null) {
      let a: Member = <Member>data;
      context.status = 1;
      context.message = "Data saved successfully. Redirecting in 2 seconds."

      setTimeout(function () {
        context.message = "";
        context.onSubmit(a);
      }, 2000)

    }
    else {
      context.status = 2;
      context.message = "Error on saving data !!!"
    }
  }

  getCircularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    };
  };

  customerSelected(customer: FormControl) {
    this.showProgress = false;
    if (customer != undefined && customer != null) {
      if (customer instanceof FormControl) {
        this.selectedMember = <Member>customer.value;
      }
      else {
        this.selectedMember = <Member>customer;
      }

      this.selectedMember.DateOfBirth = this.TransformDateObject(this.selectedMember.DateOfBirth);
      this.selectedMember.MembershipStartDate = this.TransformDateObject(this.selectedMember.MembershipStartDate);
      this.selectedMember.MembershipExpiryDate = this.TransformDateObject(this.selectedMember.MembershipExpiryDate);
      this.setProfileImage(this.selectedMember);
      this.searchedmember.data.reset();
      if (!this.selectedMember.Reminders) {
        this.selectedMember.Reminders = [];
      }
      this.incompleteReminders = this.selectedMember.Reminders.filter(r => !r.IsCompleted).length;
      //this.populateReminders();
      this.populateFollowups();
    }
    else {
      alert('no member selected');
    }
  }


  consultantChange(cons: any, idx: number) {
    if (cons != null) {
      //Set Trainer Commission if not provided
      for (var i = 0; i < this.selectedMember.UserMemberships.length; i++) {
        if (idx == i) {
          if (this.selectedMember.UserMemberships[i].IsPersonalized) {
            this.selectedMember.UserMemberships[i].CommissionPerc = cons.VariablePerc;
          }
        }
      }
    }
  }

  buildComponentControls = (): void => {


  }

  showCustomerAdd() {
    this.modal.open('modal', false);
  }

  translateFormToPost() {
    //let product: IProduct = new Product();
    //product = <IProduct>this.productForm.value.genericDetails.value;
    let member: any = null;
    this.memberFormToPost = this.fb.group(member);
  }

  GetDataToEdit(id: number) {
    this.showProgress = true;
    //let prd: any = this._service.get(Global.BASE_USER_ENDPOINT() + Global.ProductController + "?Id=" + id);
    this._service
      .getData(Global.BASE_USER_ENDPOINT() + Global.GuestMemberController + Global.getSingleItemParameters(id))
      .then((x) => {
        this.showProgress = false;
        if (x != null && x.FirstName && x.FirstName != "") {
          this.PopulateDataToEdit(<Member>x);
        }
      })
      .catch(error => { this.showProgress = false; Global.Log(error); });
  }

  PopulateDataToEdit(prd: Member) {
    this.selectedMember = prd;
    this.selectedMember.DateOfBirth = this.TransformDateObject(this.selectedMember.DateOfBirth);
    this.selectedMember.CreateDate = this.TransformDateObject(this.selectedMember.CreateDate);
    this.selectedMember.LastupdateDate = this.TransformDateObject(this.selectedMember.LastupdateDate);
    //Invoice Details
    if (this.selectedMember.InvoiceDetails && this.selectedMember.InvoiceDetails.length > 0) {
      for (var inv = 0; inv < this.selectedMember.InvoiceDetails.length; inv++) {
        if (inv == 0)
          this.selectedInvoiceId = this.selectedMember.InvoiceDetails[inv].InvoiceId;

        this.selectedMember.InvoiceDetails[inv].InvoiceDate = this.TransformDateObject(this.selectedMember.InvoiceDetails[inv].InvoiceDate);
      }
    }
    else {
      this.selectedMember.InvoiceDetails = [];
      this.selectedMember.InvoiceDetails.push(new MemberInvoice());
      this.selectedMember.InvoiceDetails[0].InvoiceDate = new Date();
      this.selectedMember.InvoiceDetails[0].InvoiceId = 0;
      this.selectedMember.InvoiceDetails[0].IsGstIncludedInPrice = true;
      this.selectedMember.InvoiceDetails[0].PaymentDetails = [];
    }

    //User Membership
    if (this.selectedMember.UserMemberships != undefined && this.selectedMember.UserMemberships != null) {
      for (var umCnt = 0; umCnt < this.selectedMember.UserMemberships.length; umCnt++) {
        this.selectedMember.UserMemberships[umCnt].PlanStartDate = this.TransformDateObject(this.selectedMember.UserMemberships[umCnt].PlanStartDate);
        this.selectedMember.UserMemberships[umCnt].PlanEndDate = this.TransformDateObject(this.selectedMember.UserMemberships[umCnt].PlanEndDate);
      }
    }
    else {
      this.selectedMember.UserMemberships = [];
    }

    if (this.selectedMember.InvoiceDetails.find(inv => inv.InvoiceId == this.selectedInvoiceId)?.BalanceAmount <= 0) {
      this.newPaymentDetail.PaymentDetaildId = -1;
    }

    this.isEditMode = true;

    this.setProfileImage(this.selectedMember);

    this.selectedMember.MembershipStartDate = this.TransformDateObject(this.selectedMember.MembershipStartDate);
    this.selectedMember.MembershipExpiryDate = this.TransformDateObject(this.selectedMember.MembershipExpiryDate);

    let urlParams: string[] = this.router.url.split('/');
    this.isEditMode = !(urlParams[urlParams.length - 2] == "upgrade");
    this.isUpgradeMode = (urlParams[urlParams.length - 2] == "upgrade");

    if (!this.selectedMember.Reminders) {
      this.selectedMember.Reminders = [];
    }
    this.incompleteReminders = this.selectedMember.Reminders.filter(r => !r.IsCompleted).length;
    this.populateFollowups();
  }

  LoadFollowupDefaults() {
    if (this.SubTypeList == null || this.SubTypeList?.length <= 0) {
      this.populateReminderSubTypes();
    }
    if (this.ResponseTypeList == null || this.ResponseTypeList?.length <= 0) {
      this.populateReminderResponseTypes();
    }
  }

  private populateReminderSubTypes() {
    this._service
      .getData(Global.BASE_USER_ENDPOINT() + this.getEndpointUrl("remindersubtype", ReminderTypes.Membership))
      .then((x) => {
        if (x.ListItems) {
          this.SubTypeList = <ReminderType[]>x.ListItems;
        }
      })
      .catch(error => { Global.Log(error); this.SubTypeList = []; });
  }

  private populateReminderResponseTypes() {
    this._service
      .getData(Global.BASE_USER_ENDPOINT() + this.getEndpointUrl("reminderresponsetype", 0))
      .then((x) => {
        if (x.ListItems) {
          this.ResponseTypeList = <ReminderResponseType[]>x.ListItems;
        }
      })
      .catch(error => { Global.Log(error); this.ResponseTypeList = []; });
  }

  getEndpointUrl(apiname: string, id: number): string {
    let apiPath: string = "";
    switch (apiname) {
      case "remindertype":
        apiPath = Global.ReminderTypesListEndpoint;
        break;
      case "remindersubtype":
        apiPath = Global.ReminderSubTypesListEndpoint + Global.getSingleItemParameters(id);
        break;
      case "reminderresponsetype":
        apiPath = Global.ReminderResponseTypesListEndpoint;
        break;
      default:
        apiPath = "";
        break;
    }

    return apiPath;
  }

  setProfileImage(member: Member) {
    if (member.UserImages) {
      var profileImg = member.UserImages.find(img => img.IsCoverPhoto == true);
      if (profileImg) {
        this.profileImageUrl = profileImg.ImagePath;
      }
      else {
        this.profileImageUrl = "assets/images/profile_icon_small.png";
      }
    }
    else {
      this.profileImageUrl = "assets/images/profile_icon_small.png";
    }
  }

  TransformDateObject(d) {
    if (d != undefined && d != null)
      d = new Date(d);

    if ((<Date>d).getFullYear() == 1)
      d = new Date();

    return d;
  }

}


const group = (items, fn) => items.reduce((prev, next) => {
  const prop = fn(next);
  return {
    ...prev,
    [prop]: prev[prop] ? [...prev[prop], next] : [next],
  };
}, {});

// Accepts the array and key
const groupBy = (array, key) => {
  // Return the end result
  return array.reduce((result, currentValue) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    if (!result[currentValue[key]]) {
      result[currentValue[key]] = [];
    }
    result[currentValue[key]].push(currentValue);
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}); // empty object is the initial value for result object
};


import { NgxSmartModalService } from 'ngx-smart-modal';
import { FitnessGoalType, PhotoIdType, PricingModel } from '../Shared/fb.enum';

import { GlobalSettings } from '../Models/GlobalSettings';
import { InvoiceSetting } from '../Models/InvoiceSetting';
import { MemberInvoice } from '../Models/FitnessBox/MemberInvoice';
import { UserAddress } from '../Models/FitnessBox/UserAddress';
import { UserMembershipPlan } from '../Models/FitnessBox/UserMembershipPlan';
import { PayMode } from '../Shared/invoice-enum';
import { InvoicePrintData } from '../Models/InvoicePrintData';
import { ReminderType } from '../Models/Common/ReminderType';
import { ReminderResponseType } from '../Models/Common/ReminderResponseType';
export class DataComponent implements IComponent {
  total: number;
  msg: string;
  dataStatus: DataStatus;
  dbops: DBOperation;
  perPage: number;
  pageNum: number;
  modal: NgxSmartModalService;
  loading: boolean;
  indLoading: boolean;
  isDataRefreshed: boolean;
  filter: string;
  sortData: string;
  Load(perpage: number, pn: number, rowsToCache: number): void {
  }
  add() {
  }

  edit(id: number) {
  }

  delete(id: number) {
  }
}
